import React from 'react'
import { connect } from 'react-redux'
import isNil from 'lodash/isNil'
import NorthWind from '../../../../../../asset/wind-preview-green.png'
class IdealWind extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { idealWinds } = this.props

    return (
      <div className='horizontal-center'>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: '88px', textAlign: 'center' }}>
            Ideal Wind
            <div style={{
              height: '88px',
              width: '88px',
              position: 'relative',
              marginTop: '5px',
              border: '1px solid #959595',
              borderRadius: '50%'
            }}>
              <img className='ideal-wind-preview-toolbar north-wind'
                style={{ visibility: idealWinds.indexOf('n') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar north-east-wind'
                style={{ visibility: idealWinds.indexOf('ne') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar east-wind'
                style={{ visibility: idealWinds.indexOf('e') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar south-east-wind'
                style={{ visibility: idealWinds.indexOf('se') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar south-wind'
                style={{ visibility: idealWinds.indexOf('s') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar south-west-wind'
                style={{ visibility: idealWinds.indexOf('sw') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar west-wind'
                style={{ visibility: idealWinds.indexOf('w') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
              <img className='ideal-wind-preview-toolbar north-west-wind'
                style={{ visibility: idealWinds.indexOf('nw') !== -1 ? 'visible' : 'hidden' }}
                src={NorthWind}>
              </img>
            </div>
          </div>
          <button
            onClick={this.props.toggleEditing}
            style={{
              backgroundColor: '#589500', width: '30%', top: '15px', position: 'relative'
            }}>
            Edit
          </button>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
})

export default connect(() => { return {} }, mapDispatchToProps)(IdealWind)